import { createContext, useContext, useLayoutEffect, useEffect, useMemo, useRef, useId } from 'react';
import { createFeedback, feedback } from './feedback.js';

const useBrowserLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
const FeedbackContext = createContext(feedback);
export function FeedbackProvider({ scope = 'public', children }) {
  const current = useRef(null);
  const channel = useMemo(() => {
    const token = {};
    return { token, api: createFeedback(() => current.current === token) };
  }, [scope]);
  useBrowserLayoutEffect(() => {
    current.current = channel.token;
    return () => { current.current = null; feedback.dismiss(); };
  }, [channel]);
  return <FeedbackContext.Provider value={channel.api}>{children}</FeedbackContext.Provider>;
}
export function useFeedback() {
  const channel = useContext(FeedbackContext);
  const instance = useId();
  return useMemo(() => {
    const ids = new Map();
    const options = value => {
      if (value?.id === undefined) return value;
      const id = `${instance}:${value.id}`;
      ids.set(value.id, id);
      return { ...value, id };
    };
    return Object.assign((message, value) => channel(message, options(value)),
      Object.fromEntries(['success','error','info','warning','loading'].map(kind => [kind, (message, value) => channel[kind](message, options(value))])),
      { isCurrent: channel.isCurrent, dismiss: id => channel.dismiss(ids.get(id) ?? id) });
  }, [channel, instance]);
}
